<template>
  <div class="bottom-nav-bar" :class="{ 'with-download-banner': bannerVisible }">
    <div
      v-for="item in leftItems"
      :key="item.name"
      class="bottom-nav-item"
      :class="{ active: isActive(item) }"
      @click="go(item.path)"
    >
      <van-icon :name="item.icon" size="22" />
      <span class="bottom-nav-label">{{ $t(item.i18nKey) }}</span>
    </div>
    <!-- 中间凸起「+」：发起 AI 需求澄清（对齐 client/ custom_bottom_nav_bar 的中央按钮） -->
    <div v-if="aiDirectChatEnabled" class="bottom-nav-center" @click="openAiChat">
      <van-icon name="plus" size="24" color="#fff" />
    </div>
    <div
      v-for="item in rightItems"
      :key="item.name"
      class="bottom-nav-item"
      :class="{ active: isActive(item) }"
      @click="go(item.path)"
    >
      <van-icon :name="item.icon" size="22" />
      <span class="bottom-nav-label">{{ $t(item.i18nKey) }}</span>
      <span v-if="item.badge()" class="bottom-nav-badge">{{ item.badge() }}</span>
    </div>
  </div>
</template>

<script>
import { AI_DIRECT_CHAT_ENABLED } from '@/assets/feature_flags.js'

export default {
  name: 'BottomNavBar',
  props: {
    // 下载引导条可见时，底部导航需要整体上移让位
    bannerVisible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    aiDirectChatEnabled() {
      return AI_DIRECT_CHAT_ENABLED
    },
    leftItems() {
      return [this.items[0], this.items[1]]
    },
    rightItems() {
      return [this.items[2], this.items[3]]
    },
    items() {
      const vm = this
      return [
        { name: 'channels', path: '/channels', icon: 'friends-o', i18nKey: 'home_tabHome', match: ['/channels', '/channel'] },
        { name: 'matches', path: '/matches', icon: 'like-o', i18nKey: 'tab_matches', match: ['/matches', '/matched-session'], badge: function () { return vm.matchBadge } },
        { name: 'messages', path: '/messages', icon: 'chat-o', i18nKey: 'tab_messages', match: ['/messages'], badge: function () { return vm.msgBadge } },
        { name: 'profile', path: '/personal-center', icon: 'user-o', i18nKey: 'tab_profile', match: ['/personal-center', '/settings'], badge: function () { return '' } }
      ]
    },
    matchBadge() {
      const n = parseInt(this.$store.state.unreadMatchCount, 10) || 0
      if (n > 99) return '99+'
      if (n > 0) return String(n)
      return this.$store.state.hasUnreadMatch ? '•' : ''
    },
    msgBadge() {
      const chat = parseInt(this.$store.state.unreadChatCount, 10) || 0
      const inter = parseInt(this.$store.state.unreadInteractionCount, 10) || 0
      const total = chat + inter
      if (total > 99) return '99+'
      if (total > 0) return String(total)
      return this.$store.state.hasUnreadMsg ? '•' : ''
    }
  },
  methods: {
    go(path) {
      if (this.$route.path === path) return
      this.$router.push(path)
    },
    // 打开全局独立 AI 对话弹窗（替代跳 /ai 页，对齐群内 AI 聊天弹窗交互）
    openAiChat() {
      this.$store.commit('setShowAiChatPopup', true)
    },
    isActive(item) {
      const path = this.$route.path
      return item.match.some(prefix => path === prefix || path.indexOf(prefix) === 0)
    }
  }
}
</script>

<style scoped>
.bottom-nav-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 56px;
  background: #ffffff;
  border-top: 1px solid #E0DDD8;
  display: flex;
  align-items: stretch;
  z-index: 900;
  padding-bottom: env(safe-area-inset-bottom);
}

.with-download-banner {
  bottom: 56px;
}

.bottom-nav-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  color: #8A8A8A;
  cursor: pointer;
  position: relative;
}

.bottom-nav-item.active {
  color: #E8543A;
}

.bottom-nav-label {
  font-size: 10px;
  line-height: 1;
}

.bottom-nav-badge {
  position: absolute;
  top: 6px;
  right: calc(50% - 22px);
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 8px;
  background: #E8543A;
  color: #fff;
  font-size: 10px;
  line-height: 16px;
  text-align: center;
}

/* 中间凸起「+」按钮 */
.bottom-nav-center {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: #E8543A;
  border: 3px solid #fff;
  box-shadow: 0 4px 10px rgba(232, 84, 58, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
  margin-top: -10px;
  cursor: pointer;
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/BottomNavBar.vue